/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";
import { TokenStorage } from "../../storage";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const FactorService = {
  async getByCode(code) {
    const requestScreenData = {
      url: "api/Factor",
      filter: `Code eq ${code}`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },
  async getByFactorInt(code) {
    const requestScreenData = {
      url: "api/Factor",
      filter: `FactorInt eq ${code}`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },
  async getFactors(codes) {
    let filter = codes.map((code) => `Code eq ${code}`).join(` or  `);

    const requestScreenData = {
      url: "api/Factor",
      filter: filter,
      select: ["Code", "FactorInt", "Factorc", "Inactive", "Status"],
    };

    return await ApiService.oDataGet(requestScreenData);
  },
};

export { FactorService };
